import { connect } from 'react-redux';
import { FormattedMessage, intlShape } from 'react-intl';
import { getOrder, updateOrder } from '../../../order';
import {selectFavorites, selectFilteredLocations} from '../../../../addressbook/locations';
import Address from '../../../../addressbook/components/Address';
import AddressbookInfo from '../../../../addressbook/components/AddressbookInfo';
import Bar from '../../../../../ui/Bar';
import Button from '../../../../../ui/Button';
import classNames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Page from '../../../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from '../css/Shipping.scss';
import Search from '../../../../addressbook/containers/Search';
import Alert from '../../../../../ui/Alert';
import Badge from "../../../../../ui/Badge";

export class ShippingStep extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        favorites: ImmutablePropTypes.set.isRequired,
        intl: intlShape,
        loading: PropTypes.bool,
        locations: ImmutablePropTypes.map,
        onSelect: PropTypes.func.isRequired,
        order: ImmutablePropTypes.map.isRequired,
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedAddressbookId: 0,
        };
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    getAddressbooksFromLocations(locations) {
        let res = [];
        locations.map(location => {
            const addressbookId = location.get('addressbookId');
            const addressbookName = location.getIn(['addressbook', 'name']) || location.getIn(['addressbook', 'owner', 'name']);
            const addressbookType = location.getIn(['addressbook', 'type']);
            const tmp = res.filter(entry => entry.id === addressbookId);
            if (tmp.length === 0) {
                res.push({
                    id: addressbookId,
                    name: addressbookName,
                    type: addressbookType,
                    entries: [location],
                });
            }
            else{
                res.find(entry => entry.id === addressbookId).entries.push(location);
            }
        });
        return res.sort((a, b) => {
            if (a.type === 'addressbook.personal') return -1;
            if (b.type === 'addressbook.personal') return 1;
            return 0;
        });
    }

    handleNewAddress() {
        const { order, dispatch } = this.props;
        const newOrder = order.set('shipToNewAddress', true);
        dispatch(updateOrder(newOrder));
    }

    handleClick(addressbookId) {
        const { order, dispatch } = this.props;
        const oldId = this.state.selectedAddressbookId;
        this.setState({selectedAddressbookId: addressbookId});
        if (addressbookId !== oldId) {
            const newOrder = order.set('location', null);
            dispatch(updateOrder(newOrder));
        }
    }

    render() {
        const { order, favorites } = this.props;
        const locations = this.props.locations
            .filter(location => !location.get('hidden'))
            .filter(location => location.get('address').get('regionId') === order.get('region'))
            .sort((a, b) => {
                if (favorites.contains(a.get('id')) === favorites.contains(b.get('id'))) {
                    return a.get('number') > b.get('number');
                } else if (favorites.contains(a.get('id'))) {
                    return -1;
                }
                return 1;
            });

        const filteredLocations = this.filterLocationsByAddressbook(locations, this.state.selectedAddressbookId);

        return (
            <Page.Content>
                <div className={styles.filter}>
                    <Bar.Section float='left' className={styles.actions}>
                        <Search/>
                        <Button
                            block
                            emphasis='secondary'
                            className={styles.createNewAddress}
                            onClick={this.handleNewAddress.bind(this)}
                        >
                            <FormattedMessage id='frontend.form_selector_shipping.button.new_address' />
                        </Button>
                    </Bar.Section>
                    {this.renderAddressbookFilter()}
                </div>
                {filteredLocations.map(location => {
                    const isSelected = location.get('id') === order.get('location');
                    return (
                        <div
                            className={classNames(styles.address, { [styles.isSelected]: isSelected })}
                            key={location.get('id')}
                        >
                            <Address location={location} />
                            <Bar>
                                <Bar.Section float='left'>
                                    <AddressbookInfo location={location} />
                                </Bar.Section>
                                <Bar.Section float='right'>
                                    {this.renderSelectButton(isSelected, location)}
                                </Bar.Section>
                            </Bar>
                        </div>
                    );
                }).toArray()}
                {filteredLocations.isEmpty() && (
                    <Page.Content>
                        <FormattedMessage id='frontend.addressbook.text.no_addresses' />
                    </Page.Content>
                )}
            </Page.Content>
        );
    }

    renderSelectButton(isSelected, location) {
        const { onSelect, tenant, order, products } = this.props;

        const banned = location.get('bannedTenants').some(entry => {
            return entry.get('codePart') === tenant.get('code_part');
        });

        const declined = location.get('declined');

        if (banned) {
            return (
                <Alert type='info'>
                    <FormattedMessage id='frontend.form_selector_shipping.hint.banned' />
                </Alert>
            );
        }

        const deliveryPositions = order.get('positions').get(2);
        const blacklistedLocationProducts = location.get('blacklisted');

        const blacklistedProducts = deliveryPositions && blacklistedLocationProducts.filter(product => {
            return deliveryPositions.has(product);
        }).map(id => {
            return products.find(entry => id === entry.get('id'));
        }).toArray();

        if (blacklistedProducts && blacklistedProducts.length) {
            return (
                <Alert type='info'>
                    <FormattedMessage id='frontend.form_selector_shipping.hint.location.blacklist_addendum' />
                    {
                        blacklistedProducts.map((product, key) =>
                            <div key={key} style={{marginBottom: 0}}>
                                <strong>
                                    <FormattedMessage id={product.get('alias')} />
                                </strong>
                            </div>
                        )
                    }
                </Alert>
            );
        }

        if (declined) {
            return (
                <Alert type='warning'>
                    <FormattedMessage id='frontend.form_selector_shipping.hint.location.declined_addendum' />
                </Alert>
            );
        }

        return (
            <Button
                emphasis='secondary'
                onClick={e => onSelect(e, location)}
            >
                {isSelected ? (
                    <FormattedMessage
                        id='frontend.form_selector_shipping.headline.selected_address'
                    />
                ) : (
                    <FormattedMessage
                        id='frontend.form_selector_shipping.headline.select_address'
                    />
                )}

            </Button>
        );
    }

    filterLocationsByAddressbook(locations, addressbookId) {
        if (addressbookId === 0) {
            return locations;
        }
        return locations.filter(location => location.get('addressbookId') === addressbookId);
    }

    renderAddressbookFilter() {
        const { order, favorites } = this.props;

        const locations = this.props.locations
            .filter(location => !location.get('hidden'))
            .filter(location => location.get('address').get('regionId') === order.get('region'))
            .sort((a, b) => {
                if (favorites.contains(a.get('id')) === favorites.contains(b.get('id'))) {
                    return a.get('number') > b.get('number');
                } else if (favorites.contains(a.get('id'))) {
                    return -1;
                }
                return 1;
            });

        const locationCount = locations.count();
        const addressbooks = this.getAddressbooksFromLocations(locations);

        return (
            <div>
                {addressbooks.length > 0 ? <Button size='small'
                    emphasis={this.state.selectedAddressbookId === 0 ? 'secondary' : 'default'}
                    key={0}
                    onClick={() => this.handleClick(0)}>
                    <FormattedMessage id='frontend.addressbook.text.all_addresses'/>
                    <Badge emphasis='light'>{locationCount}</Badge>
                </Button> : null}
                {addressbooks ?
                    addressbooks.map(addressbook => (
                        <Button size='small'
                            emphasis={this.state.selectedAddressbookId === addressbook.id ? 'secondary' : 'default'}
                            key={addressbook.id}
                            onClick={() => this.handleClick(addressbook.id)}>
                            {addressbook.type === 'addressbook.personal' ? (
                                <FormattedMessage id='frontend.form_selector_addressbook.select.option.personal_addressbook' />
                            ) : addressbook.name}
                            <Badge emphasis='light'>{addressbook.entries.length}</Badge>
                        </Button>
                    )) : null}
            </div>
        );
    }
}

export default connect(state => ({
    favorites: selectFavorites(state),
    locations: selectFilteredLocations(state),
    order: getOrder(state),
    products: Array.from(state.products.values()),
    tenant: state.tenant,
}))(ShippingStep);
